define('module/ugc-photowall',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub',
    'isotope'
], function($, _, Cnf, Pubsub, Isotope) {
    'use strict';

    /**
     * handle photowall
     * 
     * @jira FDZ-491
     * @date 2021-07-07
     * @author sh@sopg.de
     */

    return function()
    {
        this.oPubsub = new Pubsub();

        this.cnf = {
            selector: {
                el: '.ce-ugc-photowall',
                wall: '.item-wall',
                wallItem : '.item',
                toggle: '[name="ugctoggle"]',
                more: '.button-submit',
                template: '#ugc-item-template',
                templateLb: '#ugc-lightbox-template',
                templateLbNav: '.nav',
                templateLbVideo: '[data-type="video"]'
            },
            script : {
                q3video : 'https://player.3qsdn.com/js3q.latest.js'
            }
        };

        /**
         * main entry
         */
        this.init = function()
        {
            this.$el = Cnf.$app.find(this.cnf.selector.el);
            if(this.$el.length <= 0) {
                return;
            }
            
            this.oUgc = {};
            this.o3QVideo;

            this.initElement();
            this.initIsotope();
            this.initEvent();

            //trigger initial by small delay
            _.delay(_.bind(this.triggerInit, this), 500);
        }

        /**
         * init element
         */
        this.initElement = function()
        {
            _.each(this.$el, function(item, index) {

                //build form data
                var oData = {};
                _.each(this.$el.eq(index).find('input[type="hidden"]'), function(item){
                    oData[item.name] = item.value;
                }, oData);

                //reference to ugc item
                this.oUgc[index] = {
                    index: index,
                    $el: this.$el.eq(index),
                    $wall: this.$el.eq(index).find(this.cnf.selector.wall),
                    $toggle: this.$el.eq(index).find(this.cnf.selector.toggle),
                    $more: this.$el.eq(index).find(this.cnf.selector.more),
                    data : oData,
                    template: this.$el.eq(index).find(this.cnf.selector.template).html(),
                    templateLb: this.$el.eq(index).find(this.cnf.selector.templateLb).html(),
                    oWall: {},
                    oIsotope: {},
                    busy: false
                };

                //set wall collections
                var type;
                _.each(this.oUgc[index].$wall, function(item, wallIndex) {
                    type = this.oUgc[index].$wall.eq(wallIndex).closest('[data-ugctoggle]').data('ugctoggle');
                    this.oUgc[index].oWall[type] = {
                        index: index,
                        type: type,
                        $el: this.oUgc[index].$wall.eq(wallIndex),
                        aItem: [],
                        aItemTarget: [],
                        offset: (type === 'video') ? (parseInt(this.oUgc[index].data.limit) *-1) : 0
                    };

                    //fetch item data
                    var $item = this.oUgc[index].$wall.eq(wallIndex).find(this.cnf.selector.wallItem);
                    _.each($item, function(item, itemIndex) {
                        this.oUgc[index].oWall[type].aItem.push($item.eq(itemIndex));
                        this.oUgc[index].oWall[type].aItemTarget.push($item.eq(itemIndex).data('target'));
                    }, this);
                }, this);

            }, this);
        }

        /**
         * init event
         * 
         * @returns 
         */
        this.initEvent = function()
        {
            //add listener on toggle
            _.each(this.oUgc, function(item, index) {
                this.oUgc[index].$toggle.on('change', _.bind(this.toggle, this, index));
            }, this);

            //add listener on more
            _.each(this.oUgc, function(item, index) {
                this.oUgc[index].$more.on('click', _.bind(this.more, this, index));
            }, this);

            //add listener on items per wall
            _.each(this.oUgc, function(ugc, index) {
                _.each(this.oUgc[index].oWall, function(wallItem, wallIndex) {
                    _.each(this.oUgc[index].oWall[wallIndex].aItem, function(item, itemIndex) {
                        this.oUgc[index].oWall[wallIndex].aItem[itemIndex].on('click', _.bind(this.showLightbox, this, index, wallIndex, itemIndex));
                    }, this)
                }, this);
            }, this);
        }

        /**
         * trigger init
         */
        this.triggerInit = function()
        {
            //trigger hidden video button on load
            _.each(this.oUgc, function(item, index) {
                _.each(this.oUgc[index].$more, function(more, moreIndex) {
                    switch(this.oUgc[index].$more.eq(moreIndex).closest('[data-ugctoggle]').data('ugctoggle')) {
                        case 'video':
                            this.oUgc[index].$more.eq(moreIndex).trigger('click', index);
                            break;

                        default:break;
                    }
                }, this)
            }, this);
        }

        /**
         * callback on change toggle
         * 
         * @param {object} ev 
         */
        this.toggle = function(index, ev)
        {
            this.updateIsotope(index, ev.currentTarget.id);
        }

        /**
         * callback on click more
         * 
         * @param {int} index 
         * @param {object} ev 
         */
        this.more = function(index, ev)
        {
            if(false !== this.oUgc[index].busy) {
                return;
            }
            this.oUgc[index].busy = true;

            //current el
            var $el = $(ev.currentTarget),
                type = $el.closest('[data-ugctoggle]').data('ugctoggle');

            $el.addClass('pending disabled');
                
            //increase offset
            this.oUgc[index].oWall[type].offset = this.oUgc[index].oWall[type].offset + parseInt(this.oUgc[index].data.limit);

            //trigger api call
            $.ajax({
                url:window.cnf.host + window.cnf.api,
                dataType:'json',
                method:'post',
                data:  _.extend({}, this.oUgc[index].data, {
                    type: type,
                    offset: this.oUgc[index].oWall[type].offset
                }),
                complete:_.bind(function(index, type, xhr) {
                    //unlock button
                    this.oUgc[index].busy = false;

                    try {
                        if(
                            (xhr.status === 200)
                            && (xhr.responseJSON.success)
                            && (xhr.responseJSON.success.item)
                            && (xhr.responseJSON.success.item.length > 0)
                        ) {
                            $el.removeClass('pending disabled');
                            var template;
                            _.each(xhr.responseJSON.success.item, function(item) {

                                //build template
                                template = this.oUgc[index].template
                                    .replace(/__IMAGE__/, item.image)
                                    .replace(/__CAPTION__/, item.caption)
                                    .replace(/__TARGET__/, JSON.stringify(item.target))
                                    .replace(/__TYPE__/, type);
                                
                                //trigger append
                                this.append(index, type, $(template));
                                
                            }, this)
                        } else {
                            TweenMax.to($el, 1, {
                                autoAlpha: 0
                            });
                        }

                    } catch(e) {
                        TweenMax.to($el, 1, {
                            autoAlpha: 0
                        });
                        console.log(e);
                    }
                }, this, index, type)
            });
        }

        /**
         * trigger show lightbox
         * 
         * @param {int} index 
         * @param {string} type
         * @param {int} item
         */
        this.showLightbox = function(index, type, item)
        {
            var oData = {
                index: index,
                type: type,
                item: item
            };

            this.oPubsub.trigger(Pubsub.LIGHTBOX_SHOW, {
                html: this.getLightboxHtml(oData),
                onReady: _.bind(this.onLightboxReady, this, oData)
            });
        }

        /**
         * get rendered html by given params
         * 
         * @param {object} ev 
         * @returns string
         */
        this.getLightboxHtml = function(ev)
        {
            return this.oUgc[ev.index].templateLb
                .replace(/__TARGET_MOBILE__/, this.oUgc[ev.index].oWall[ev.type].aItemTarget[ev.item].mobile)
                .replace(/__TARGET_DESKTOP__/, this.oUgc[ev.index].oWall[ev.type].aItemTarget[ev.item].desktop)
                .replace(/__CAPTION__/, this.oUgc[ev.index].oWall[ev.type].aItemTarget[ev.item].caption)
                .replace(/__TYPE__/, ev.type);
        }

        /**
         * callback on lightbox ready
         * 
         * @param {object} ev 
         */
        this.onLightboxReady = function(ev, $lb)
        {
            //add listener on nav
            var $nav = $lb.find(this.cnf.selector.templateLbNav);
            _.each($nav, function(item, index) {
                $nav.eq(index).on('click', _.bind(this.onLbNavClick, this, ev, item.dataset.nav));
            }, this);

            //disable appropriate nav items
            if(ev.item<=0) {
                $nav.filter('[data-nav="prev"]').addClass('disabled');
            }
            if(ev.item>=(this.oUgc[ev.index].oWall[ev.type].aItemTarget.length -1)) {
                $nav.filter('[data-nav="next"]').addClass('disabled');
            }

            //add listener on video
            $lb.find(this.cnf.selector.templateLbVideo).find('picture').on('click', _.bind(this.playVideo, this, ev));
        }

        /**
         * callback on lb nav click
         * 
         * @param {object} ev 
         * @param {string} nav 
         */
        this.onLbNavClick = function(ev, nav)
        {
            if(nav === 'prev') {
                this.gotoPrevious(ev);
            } else {
                this.gotoNext(ev);
            }
        }

        /**
         * goto previous item on lb
         * 
         * @param {object} ev 
         */
        this.gotoPrevious = function(ev)
        {
            if(ev.item>=1) {
                var oData = {
                    index: ev.index,
                    type: ev.type,
                    item: ev.item -1
                };
                this.oPubsub.trigger(Pubsub.LIGHTBOX_UPDATE_CONTENT, {
                    html: this.getLightboxHtml(oData),
                    onReady: _.bind(this.onLightboxReady, this, oData)
                });
            }
        }

        /**
         * goto next item on lb
         * 
         * @param {object} ev 
         */
        this.gotoNext = function(ev)
        {
            if(ev.item<(this.oUgc[ev.index].oWall[ev.type].aItemTarget.length -1)) {
                var oData = {
                    index: ev.index,
                    type: ev.type,
                    item: ev.item +1
                };
                this.oPubsub.trigger(Pubsub.LIGHTBOX_UPDATE_CONTENT, {
                    html: this.getLightboxHtml(oData),
                    onReady: _.bind(this.onLightboxReady, this, oData)
                });
            }
        }

        /**
         * play video by given data
         * 
         * @param {object} data 
         * @param {object} ev 
         */
        this.playVideo = function(data, ev)
        {
            console.log(data);
            console.log(this.oUgc[data.index].oWall[data.type].aItemTarget[data.item]);
            var $el = $(ev.currentTarget);
            $el.off('click')
                .attr('data-status', 'pending');

            this.q3VideoRequirements()
                .then(_.bind(function() {

                    $.ajax({
                        url:window.cnf.host + window.cnf.api,
                        dataType:'json',
                        method:'post',
                        data:  _.extend({}, this.oUgc[data.index].data, {
                            fileid: this.oUgc[data.index].oWall[data.type].aItemTarget[data.item].id,
                            action: this.oUgc[data.index].data.action_playout
                        }),
                        complete:_.bind(function(xhr) {
                            //stop pulse after some delay to ensure iframe is loaded
                            _.delay(function(){
                                $el.attr('data-status', 'play');
                            }, 1000);
                            
                            try {
                                if(
                                    (xhr.status === 200)
                                    && (xhr.responseJSON.success)
                                    && (xhr.responseJSON.success.item)
                                    && (xhr.responseJSON.success.item.Id)
                                ) {
                                    //set unique id to parent element
                                    var uniqueId = 'q3video-id-' + xhr.responseJSON.success.item.Id;

                                    /**
                                     * 3q does not work with requirejs, so embed silly iframe
                                     */
                                    $el.append('<iframe id="' + uniqueId + '" src="https://playout.3qsdn.com/embed/' + xhr.responseJSON.success.item.Id + '" frameborder="0" scrolling="no" allowfullscreen></iframe>');
                                    
                                    return;
                
                                    $el.attr('id', uniqueId);
                
                                    //init q3 player
                                    this.o3QVideo = new js3q({
                                        dataid: xhr.responseJSON.success.item.Id,
                                        container: uniqueId
                                    });
                                }
                            }  catch(e) {
                                console.log(e);
                            }
                        }, this)
                    });

                }, this));
        }

        /**
         * check 3q requirements
         * 
         * @returns deferred
         */
        this.q3VideoRequirements = function()
        {
            var def = new $.Deferred();

            /**
             * 3q doesnt work on requirejs, so break here
             */
            return def.resolve();

            if(typeof this.bq3VideoRessource === 'undefined') {
                $.getScript(this.cnf.script.q3video).done(_.bind(function(){
                    this.bq3VideoRessource = true;
                    def.resolve();
                }, this));
            } else {
                def.resolve();
            }
    
            return def.promise();
        }

        /**
         * init all isotope
         * 
         * @returns 
         */
        this.initIsotope = function()
        {
            _.each(this.oUgc, function(item, index) {
                _.each(this.oUgc[index].oWall, function(wall, type) {

                    //assign isotop instance by toggle index
                    this.oUgc[index].oIsotope[type] = new Isotope(wall.$el.get(0), {
                        layoutMode:'masonry',
                        itemSelector: this.cnf.selector.wallItem
                    });

                }, this);
            }, this);
        };

        /**
         * destroy all isotope
         */
        this.destroyIsotope = function()
        {
            _.each(this.oUgc, _.bind(function(item, index) {
                _.each(this.oUgc[index].oIsotope, function(isotope, indexIsotope) {
                    this.oUgc[index].oIsotope[indexIsotope].destroy();
                    this.oUgc[index].oIsotope[indexIsotope] = null;
                }, this);
            },this));
        };

        /**
         * update isotope for given index by name
         * 
         * @param {int} index 
         */
        this.updateIsotope = function(index, name)
        {
            this.oUgc[index].oIsotope[name].layout();
        };

        /**
         * append given item for given index, trigger isotope
         * 
         * @param {object} arg 
         */
        this.append = function(index, name, $item)
        {
            //add to given wall, trigger appended
            this.oUgc[index].oIsotope[name].$element.append($item);
            this.oUgc[index].oIsotope[name].appended($item);

            //push to internal storage, add listener on click
            var iLength = this.oUgc[index].oWall[name].aItem.push($item);
            this.oUgc[index].oWall[name].aItemTarget.push($item.data('target'));
            $item.on('click', _.bind(this.showLightbox, this, index, name, (iLength -1)));

            //trigger update by delay to ensure dom is ready
            _.delay(_.bind(function() {
                this.updateIsotope(index, name);
            }, this, index, name), 100);
            _.delay(_.bind(function() {
                this.updateIsotope(index, name);
            }, this, index, name), 500);
            _.delay(_.bind(function() {
                this.updateIsotope(index, name);
            }, this, index, name), 2000);
        };
        
        /**
         * remove given item for given index, trigger isotope
         * 
         * @param {object} arg 
         */
        this.remove = function(index, name, $item)
        {
            this.oUgc[index].oIsotope[name].remove($item);

            //trigger update after delay to ensure dom ready
            _.delay(_.bind(function() {
                this.updateIsotope(index, name);
            }, this, index, name), 100);
        };

        this.init();
    };
});

